import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_6qajwqdzz3: FaireBrandEntity = {
  token: "b_6qajwqdzz3",
  type: "brand",
  name: "BigMouth Inc",
  avatarUrl:
    "https://cdn.faire.com/fastly/1face81d43228c79aaeab9593f5daee2740274996dcc303d11be3caaa3771ca9.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/b52d672f2862a1a6e42dbc0b1f1791a08810b791020558a8ab3011bd4f3811b6.png",
  logoUrl:
    "https://cdn.faire.com/fastly/1face81d43228c79aaeab9593f5daee2740274996dcc303d11be3caaa3771ca9.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/b52d672f2862a1a6e42dbc0b1f1791a08810b791020558a8ab3011bd4f3811b6.png",
  location: "Omaha, NE, USA",
  minimumOrderDollars: 139,
  rating: 4.6,
  reviewCount: 91,
  isTopShop: true,
  isInsider: true,
  description:
    "BigMouth creates ridiculously fun products that turn everyday moments into unforgettable laughs. With bold humor, unexpected designs, and a playful spirit, we’re the go-to brand for anyone who refuses to take life too seriously.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:51:58.653Z",
    importedBy: "entity-db-cli",
  },
};
